
import type { Period } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { DateRangeFilter, FiltersMessages } from '../../models'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { DateUtils } from '../../utils/date.utils'
import { FiltersUtils } from '../../utils/filters.utils'
import DateRangePickerSelector from '../date-range-picker/date-range-picker-selector.component.vue'

export default defineComponent({
  name: 'DateRangePickerFilterSelector',
  components: {
    DateRangePickerSelector,
  },
  props: {
    filter: {
      type: Object as PropType<DateRangeFilter>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const ctx = getCurrentInstance()
    if (!ctx) {
      throw new Error("'ctx' is not defined")
    }

    const baseClass = 'epb-date-range-picker-filter-selector'
    const messages = ctx.proxy.$epb.messages.filters as FiltersMessages

    const label = FiltersUtils.getLabel(props.filter.config, messages)

    function formatSelectedValuesToPeriod(selectedValues: string[]): Period<Date> {
      const [startString, endString] = selectedValues

      return {
        start: DateUtils.convertUTCToLocalDisplay(new Date(startString)),
        end: DateUtils.convertUTCToLocalDisplay(new Date(endString)),
      }
    }

    const dateRangeValues = computed(() => {
      const [start, end] = props.filter.selectedValues || []
      if (!start || !end) {
        return { start: undefined, end: undefined }
      }

      const selectedValuesAsPeriod = formatSelectedValuesToPeriod(props.filter.selectedValues)
      return selectedValuesAsPeriod
    })

    function onSelectedValuesChange(values: Period<Date>) {
      if (!values.start || !values.end) {
        emit('selectedValuesChange', [undefined, undefined])
        return
      }

      emit('selectedValuesChange', [
        DateUtils.getISOStringWithoutMillisecondsAndZ(values.start),
        DateUtils.getISOStringWithoutMillisecondsAndZ(values.end),
      ])
    }

    return {
      baseClass,
      messages,
      label,
      dateRangeValues,
      onSelectedValuesChange,
    }
  },
})
